<template>
    <hm-content>
        <div>
            <el-radio-group
                    v-model="tagChange"
                    size="small"
                    @change="tagChangeFun"
            >
                <el-radio-button label="mySelection">我的选品</el-radio-button>
                <el-radio-button label="selectMarket">选品市场</el-radio-button>
            </el-radio-group>
        </div>
        <div v-if="tagChange == 'mySelection'" style="margin-top: 20px;">
            <div class="flex flex-end">
                <el-input placeholder="请输入商品名称/货号" size="small" class="mr10" v-model="queryWord" clearable style="width: 200px;"></el-input>
                <el-button type="primary" size="small" @click="queryWordFun">查询</el-button>
            </div>
            <el-table
                :data="mySelectionData"
                v-if="tagChange == 'mySelection'"
                :key="2"
            >
                <el-table-column
                        align="cneter"
                        label="序号"
                        type="index"
                        width="55"
                        :index="index => index + (currentPage - 1) * pageSize + 1"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="商品名称"
                        width="300"
                        prop="spuName"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="商品货号"
                        prop="goodsSn"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="商品类型"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isOverseas == 'yes'">跨境购</span>
                        <span v-else>一般</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="商品状态"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.saleState == 'yes'" style="color: green;">在售</span>
                        <span v-else style="color: red">停售</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="采购价"
                >
                    <template slot-scope="scope">
                        <span>￥{{scope.row.showPurchasePrice}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="建议零售价"
                >
                    <template slot-scope="scope">
                        <span>￥{{scope.row.showRecommendedRetailPrice}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="进货总库存"
                        prop="totalStockNum"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="剩余库存"
                        prop="totalActualStockNum"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="进货商"
                        prop="supplierName"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="操作"
                        fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button type="text" style="color: #0081E5;" @click="addInventory(scope.row.spuId)">增加库存</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="hm-pagination">
                <el-pagination
                        background
                        :total="total"
                        @current-change="paging"
                        @size-change="handleSizeChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="currentPage"
                ></el-pagination>
            </div>
        </div>
        <div v-if="tagChange == 'selectMarket'" style="margin-top: 20px;">
            <p style="line-height: 30px; color: #2d8cf0;">当前选品市场内的商品为您的签约供应商提供</p>
            <div class="flex flex-between">
                <el-select v-model="provider" @change="changeProvider" style="width: 200px;">
                    <el-option
                            v-for="(v,i) in storeList"
                            :value="{lable:v.storeCode,value:v.storeName}"
                            :label="v.storeName"
                            :key="i"
                    ></el-option>
                </el-select>
                <el-button type="text" @click="batchPurchaseWindow = true">批量进货</el-button>
            </div>
            <el-table
                    ref="multipleTable"
                    :data="selectionMarketList"
                    v-if="tagChange == 'selectMarket'"
                    :key="1"
            >
                <el-table-column
                        type="selection"
                        align="center"
                        width="55"
                >
                </el-table-column>
                <el-table-column
                        align="cneter"
                        label="序号"
                        type="index"
                        width="55"
                        :index="index => index + (currentPage - 1) * pageSize + 1"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="商品名称"
                        prop="spuName"
                        width="300"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="商品货号"
                        prop="goodsSn"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="是否跨境购"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isOverseas == 'yes'">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="商品状态"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.saleState == 'yes'"  style="color: green;">在售</span>
                        <span v-else style="color: #999999">停售</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="采购价"
                        prop="showPurchasePrice"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="建议零售价"
                        prop="showRecommendedRetailPrice"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="供应库存"
                        prop="totalStockNum"
                ></el-table-column>
                <el-table-column
                        align="center"
                        label="供货商"
                >
                    <template>
                        <span>{{this.provider}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        align="center"
                        label="操作"
                        fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button type="text" @click="purchase(scope.row)">进货</el-button>
                        <el-dialog title="确认进货" :visible.sync="purchaseWindow" :modal="false" width="20%">
                            <div style="text-align: center; line-height: 40px; margin-bottom: 10px;">请根据您的实际业务选择进货量，选品后商品将直接发布到微店商品列表（仅支持快递配送）</div>
                            <el-button type="primary" size="small" @click="commitChangePurchase(onlySelectGoods)">确定</el-button>
                        </el-dialog>
                    </template>
                </el-table-column>
            </el-table>
            <div class="hm-pagination">
                <el-pagination
                        background
                        :total="totals"
                        @current-change="pagings"
                        @size-change="handleSizeChanges"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page="currentPages"
                ></el-pagination>
            </div>
            <el-dialog title="批量进货" :visible.sync="batchPurchaseWindow" width="20%" align="center">
                <div style="text-align: center; line-height: 40px; margin-bottom: 10px;">请根据您的实际业务选择进货量，选品后商品将直接发布到微店商品列表（仅支持快递配送）</div>
                <el-button type="primary" size="small" @click="plcommitChangePurchase" style="width: 50px">确定</el-button>
            </el-dialog>
        </div>
    </hm-content>
</template>
<script>
    export default {
        data(){
            return{
                multipleSelection:'',
                batchPurchaseWindow:false,  //批量进货窗口
                queryWord:'',
                purchaseData: {
                    purchaseNum:"",
                },
                purchaseWindow:false,   //进货窗口
                tagChange:'mySelection',
                mySelectionData:[],
                onlySelectGoods:[],
                provider:'',
                selectionMarketList:[],
                total:0,     //总条数
                currentPage: 1,
                pageSize: 10,
                totals:0,     //总条数
                currentPages: 1,
                pageSizes: 10,
                storeList:[],
                selectValue:'',
                commit:{
                    fromSpuList: [
                        {
                            fromSpuId: ""
                        }
                    ],
                    fromStoreCode: "",
                    fromStoreName: ""
                }
            }
        },
        created() {

        },
        mounted() {
            this.store_list();
            this.mySelectionPageList();
        },
        methods:{
            async addInventory(val){  //增加库存
                const { result } = await this.$store.dispatch("add_stock",{
                    spuId:val
                });
                let re = result;
                this.$message({
                    message: `增加总库存数：${re}`,
                    type: 'success'
                });
                this.mySelectionPageList();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //queryWord查询我的选品
            queryWordFun(){
                this.pageSize=10;
                this.currentPage=1;
                this.mySelectionPageList();
            },
            //我的选品列表查询
            async mySelectionPageList(){
                let params = {
                    pageSize:this.pageSize,
                    pageNo:this.currentPage,
                    queryWord: this.queryWord
                }
                const { result} = await this.$store.dispatch("my_page_third_list",params);
                this.mySelectionData = result.records;
                this.total = result.total;
            },
            async commitChangePurchase(val){   //提交进货信息

                let params = {
                    fromSpuList: [
                        {
                            fromSpuId: val.spuId
                        },
                    ],
                    fromStoreCode: this.selectValue,
                    fromStoreName: this.provider
                }
                await this.$store.dispatch("storeSelectionSpuThirdAdd",params);
                this.$message({
                    message: "进货成功",
                    type: 'success'
                });
                this.purchaseWindow = false;
                this.page_list();
            },
            async plcommitChangePurchase(){   //提交批量进货信息
                let selection =this.$refs.multipleTable.selection;
                let arr = [];

                selection.forEach(v => {
                    let obj = {
                        fromSpuId:v.spuId,
                    }
                    arr.push(obj);
                });

                let params = {
                    fromSpuList: arr,
                    fromStoreCode: this.selectValue,
                    fromStoreName: this.provider
                }
                await this.$store.dispatch("storeSelectionSpuThirdAdd",params);
                this.$message({
                    message: "进货成功",
                    type: 'success'
                });
                this.batchPurchaseWindow = false;
                this.page_list();
            },
            purchase(scope){
                this.purchaseWindow = true;
                this.onlySelectGoods = scope;
            },
            //切换供货商查询
            changeProvider(data) {
                const { value,lable } =data;
                console.log("value:",value);
                console.log("lable:",lable);
                this.selectValue = lable;
                this.provider = value;
                this.page_list();
            },
            tagChangeFun(){     //默认查询
                if(this.tagChange == "mySelection"){
                    console.log(1);
                    this.mySelectionPageList();
                }else{
                    this.page_list();
                }
            },
            pagings(page) {
                this.currentPages = page;
                this.page_list();
            },
            handleSizeChanges(size) {
                this.currentPages = 1;
                this.pageSizes = size;
                this.page_list();
            },
            paging(page){
                this.currentPage = page;
                this.mySelectionPageList();
            },
            handleSizeChange(size){
                this.currentPage = 1;
                this.pageSize = size;
                this.mySelectionPageList();
            },
            //查询供货商
            async store_list(){
                const { result } = await this.$store.dispatch("auth_store_list");
                this.storeList = result;
                this.provider = this.storeList[0].storeName;
                this.selectValue = this.storeList[0].storeCode;
            },
            //查询所有商品
            async page_list(){
                let params = {
                    pageSize:this.pageSizes,
                    pageNo:this.currentPages,
                    authStoreCode:this.selectValue
                }
                const { result } = await this.$store.dispatch("store_Selection_Spu_Info_Page_list",params);
                this.totals = result.total;
                this.selectionMarketList = result.records;
            },

        }
    }
</script>
<style scoped></style>